// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "codesandbox/v1/codesandbox.proto" (package "codesandbox.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal RPCs for the Control tab's code sandbox and the code editors'
// language servers.
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { CodeSandboxService } from "./codesandbox";
import type { StopEditorSessionResponse } from "./codesandbox";
import type { StopEditorSessionRequest } from "./codesandbox";
import type { StartEditorSessionResponse } from "./codesandbox";
import type { StartEditorSessionRequest } from "./codesandbox";
import type { RecordRunResponse } from "./codesandbox";
import type { RecordRunRequest } from "./codesandbox";
import type { CheckHealthResponse } from "./codesandbox";
import type { CheckHealthRequest } from "./codesandbox";
import type { StopProgramResponse } from "./codesandbox";
import type { StopProgramRequest } from "./codesandbox";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { RunProgramResponse } from "./codesandbox";
import type { RunProgramRequest } from "./codesandbox";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * CodeSandboxService runs a single-file program against one machine part and
 * streams its output back, and starts the editor sessions that serve the code
 * editors a language server.
 *
 * A run executes in its editor session's sandbox, or, without a session, in a
 * sandbox of its own scoped to one RunProgram call. No sandbox identifier ever
 * reaches the caller. An editor session's sandbox is the one the browser does
 * talk to: directly, over a WebSocket through the provider's connect-token
 * proxy, with a token that admits it to that one sandbox.
 *
 * @generated from protobuf service codesandbox.v1.CodeSandboxService
 */
export interface ICodeSandboxServiceClient {
    /**
     * Runs source, streaming stdout and stderr until it exits. With a session, it
     * runs in that session's sandbox, which outlives it; otherwise in a fresh
     * sandbox that ends with it. Requires control access to the part the run is
     * bound to.
     *
     * @generated from protobuf rpc: RunProgram(codesandbox.v1.RunProgramRequest) returns (stream codesandbox.v1.RunProgramResponse);
     */
    runProgram(input: RunProgramRequest, options?: RpcOptions): ServerStreamingCall<RunProgramRequest, RunProgramResponse>;
    /**
     * Stops a run started by the caller. Someone else's run is reported as
     * absent rather than denied, so run IDs cannot be probed for existence. So
     * is a session's earlier run once a newer one has started in it.
     *
     * @generated from protobuf rpc: StopProgram(codesandbox.v1.StopProgramRequest) returns (codesandbox.v1.StopProgramResponse);
     */
    stopProgram(input: StopProgramRequest, options?: RpcOptions): UnaryCall<StopProgramRequest, StopProgramResponse>;
    /**
     * Reports whether a program could run right now: the provider is configured,
     * reachable, and accepts our credentials.
     *
     * Unauthenticated in the sense that it names no part and reveals nothing
     * about one — it answers about this deployment, not about a machine.
     *
     * A deployment with no provider configured does not register this service at
     * all, so the call is Unimplemented rather than false. Both mean the same
     * thing to a caller: no server-side program can run here.
     *
     * @generated from protobuf rpc: CheckHealth(codesandbox.v1.CheckHealthRequest) returns (codesandbox.v1.CheckHealthResponse);
     */
    checkHealth(input: CheckHealthRequest, options?: RpcOptions): UnaryCall<CheckHealthRequest, CheckHealthResponse>;
    /**
     * Records that the user asked for a program to run, for usage metrics only.
     *
     * Separate from RunProgram because TypeScript never calls RunProgram: it
     * executes in a Web Worker in the user's own browser and never reaches this
     * service. Counting inside RunProgram would report every language but the
     * one most likely to be a user's first.
     *
     * Requires the same control access RunProgram does, so a caller cannot
     * attribute runs to a machine they cannot use. Nothing observable depends on
     * the response: the caller records and moves on, whatever this returns.
     *
     * @generated from protobuf rpc: RecordRun(codesandbox.v1.RecordRunRequest) returns (codesandbox.v1.RecordRunResponse);
     */
    recordRun(input: RecordRunRequest, options?: RpcOptions): UnaryCall<RecordRunRequest, RecordRunResponse>;
    /**
     * Starts a sandbox running a language server for one open editor, and
     * returns what the browser needs to connect to it.
     *
     * A code sandbox session needs control access to its part; an inline module
     * session needs write_packages on the organization that owns the module. A
     * caller who already has too many live sandboxes is refused with
     * ResourceExhausted.
     *
     * @generated from protobuf rpc: StartEditorSession(codesandbox.v1.StartEditorSessionRequest) returns (codesandbox.v1.StartEditorSessionResponse);
     */
    startEditorSession(input: StartEditorSessionRequest, options?: RpcOptions): UnaryCall<StartEditorSessionRequest, StartEditorSessionResponse>;
    /**
     * Ends a session the caller started. An unknown or already-ended session, or
     * someone else's, returns OK, so session IDs cannot be probed for existence.
     *
     * @generated from protobuf rpc: StopEditorSession(codesandbox.v1.StopEditorSessionRequest) returns (codesandbox.v1.StopEditorSessionResponse);
     */
    stopEditorSession(input: StopEditorSessionRequest, options?: RpcOptions): UnaryCall<StopEditorSessionRequest, StopEditorSessionResponse>;
}
/**
 * CodeSandboxService runs a single-file program against one machine part and
 * streams its output back, and starts the editor sessions that serve the code
 * editors a language server.
 *
 * A run executes in its editor session's sandbox, or, without a session, in a
 * sandbox of its own scoped to one RunProgram call. No sandbox identifier ever
 * reaches the caller. An editor session's sandbox is the one the browser does
 * talk to: directly, over a WebSocket through the provider's connect-token
 * proxy, with a token that admits it to that one sandbox.
 *
 * @generated from protobuf service codesandbox.v1.CodeSandboxService
 */
export class CodeSandboxServiceClient implements ICodeSandboxServiceClient, ServiceInfo {
    typeName = CodeSandboxService.typeName;
    methods = CodeSandboxService.methods;
    options = CodeSandboxService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Runs source, streaming stdout and stderr until it exits. With a session, it
     * runs in that session's sandbox, which outlives it; otherwise in a fresh
     * sandbox that ends with it. Requires control access to the part the run is
     * bound to.
     *
     * @generated from protobuf rpc: RunProgram(codesandbox.v1.RunProgramRequest) returns (stream codesandbox.v1.RunProgramResponse);
     */
    runProgram(input: RunProgramRequest, options?: RpcOptions): ServerStreamingCall<RunProgramRequest, RunProgramResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<RunProgramRequest, RunProgramResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * Stops a run started by the caller. Someone else's run is reported as
     * absent rather than denied, so run IDs cannot be probed for existence. So
     * is a session's earlier run once a newer one has started in it.
     *
     * @generated from protobuf rpc: StopProgram(codesandbox.v1.StopProgramRequest) returns (codesandbox.v1.StopProgramResponse);
     */
    stopProgram(input: StopProgramRequest, options?: RpcOptions): UnaryCall<StopProgramRequest, StopProgramResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<StopProgramRequest, StopProgramResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Reports whether a program could run right now: the provider is configured,
     * reachable, and accepts our credentials.
     *
     * Unauthenticated in the sense that it names no part and reveals nothing
     * about one — it answers about this deployment, not about a machine.
     *
     * A deployment with no provider configured does not register this service at
     * all, so the call is Unimplemented rather than false. Both mean the same
     * thing to a caller: no server-side program can run here.
     *
     * @generated from protobuf rpc: CheckHealth(codesandbox.v1.CheckHealthRequest) returns (codesandbox.v1.CheckHealthResponse);
     */
    checkHealth(input: CheckHealthRequest, options?: RpcOptions): UnaryCall<CheckHealthRequest, CheckHealthResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckHealthRequest, CheckHealthResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Records that the user asked for a program to run, for usage metrics only.
     *
     * Separate from RunProgram because TypeScript never calls RunProgram: it
     * executes in a Web Worker in the user's own browser and never reaches this
     * service. Counting inside RunProgram would report every language but the
     * one most likely to be a user's first.
     *
     * Requires the same control access RunProgram does, so a caller cannot
     * attribute runs to a machine they cannot use. Nothing observable depends on
     * the response: the caller records and moves on, whatever this returns.
     *
     * @generated from protobuf rpc: RecordRun(codesandbox.v1.RecordRunRequest) returns (codesandbox.v1.RecordRunResponse);
     */
    recordRun(input: RecordRunRequest, options?: RpcOptions): UnaryCall<RecordRunRequest, RecordRunResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<RecordRunRequest, RecordRunResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Starts a sandbox running a language server for one open editor, and
     * returns what the browser needs to connect to it.
     *
     * A code sandbox session needs control access to its part; an inline module
     * session needs write_packages on the organization that owns the module. A
     * caller who already has too many live sandboxes is refused with
     * ResourceExhausted.
     *
     * @generated from protobuf rpc: StartEditorSession(codesandbox.v1.StartEditorSessionRequest) returns (codesandbox.v1.StartEditorSessionResponse);
     */
    startEditorSession(input: StartEditorSessionRequest, options?: RpcOptions): UnaryCall<StartEditorSessionRequest, StartEditorSessionResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<StartEditorSessionRequest, StartEditorSessionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Ends a session the caller started. An unknown or already-ended session, or
     * someone else's, returns OK, so session IDs cannot be probed for existence.
     *
     * @generated from protobuf rpc: StopEditorSession(codesandbox.v1.StopEditorSessionRequest) returns (codesandbox.v1.StopEditorSessionResponse);
     */
    stopEditorSession(input: StopEditorSessionRequest, options?: RpcOptions): UnaryCall<StopEditorSessionRequest, StopEditorSessionResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<StopEditorSessionRequest, StopEditorSessionResponse>("unary", this._transport, method, opt, input);
    }
}
